/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_Github_DescInputs */

const en_ui_settings_about_github_desc = /** @type {(inputs: Ui_Settings_About_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found a bug or have a feature request? Open an issue`)
};

const de_ui_settings_about_github_desc = /** @type {(inputs: Ui_Settings_About_Github_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler gefunden oder Feature-Wunsch? Issue erstellen`)
};

/**
* | output |
* | --- |
* | "Found a bug or have a feature request? Open an issue" |
*
* @param {Ui_Settings_About_Github_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_github_desc = /** @type {((inputs?: Ui_Settings_About_Github_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_Github_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_github_desc(inputs)
	return de_ui_settings_about_github_desc(inputs)
});